<template>
  <nav class="navbar navbar-expand-lg theme-nav fixed-top">
    <div class="container">
      <router-link class="navbar-brand" to="/chatloop"
        ><img src="../../assets/images/logo.png" alt="logo"
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#mainmenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar('navbar')"
      >
        <span class="navbar-toggler-icon"
          ><i class="fa fa-align-justify" aria-hidden="true"></i
        ></span>
      </button>
      <div
        class="collapse navbar-collapse"
        id="mainmenu"
        :class="responsiveNav ? 'show' : ''"
      >
        <ul class="navbar-nav ml-auto" id="mymenu">
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#home"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#about"
              >about</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#feature"
              >feature</router-link
            >
          </li> 
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#screenshots"
              >screenshot</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#team"
              >team</router-link
            >
          </li>
          <li class="nav-item dropdown" @click="toggleNavbar('blogList')">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >Blog</a
            >
            <ul class="dropdown-menu" :class="responsiveBlogList ? 'show' : ''">
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blog-list"
                  >blog list</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blog-details"
                  >blog details</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blogs-leftside"
                  >leftsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/blogs-rightside"
                  >rightsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/rtl/blog-details-with-left-sidebar"
                  >details leftsidebar
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/rtl/blog-details-with-right-sidebar"
                  >details rightsidebar
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/rtl#contact"
              >contact us</router-link
            >
          </li> 
          <li class="nav-item dropdown" @click="toggleNavbar('otherPagesList')">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >Other Page</a
            >
            <ul
              class="dropdown-menu"
              :class="responsiveOthePageslist ? 'show' : ''"
            >
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/sign-in"
                  >Sign In</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/sign-up"
                  >Sign Up</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/forgot-password"
                  >Forget Password</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/thank-you"
                  >Thank You</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/review"
                  >Review</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/FAQ-page"
                  >FAQ</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/coming-soon"
                  >Coming Soon</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/download"
                  >Download</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/request"
                  >Request Demo</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/rtl/404"
                  >404</router-link
                >
              </li>
            </ul>
          </li> 
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      scrollpage: 0,
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
    };
  },
  methods: {
    handleScroll: function (event) {
      this.scrollpage = window.scrollY;
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>
<style></style>
